// Vehicle Data Version core
export function vehicleDataVersionCore() {
    const endpoint = '/saleschannels/vehicleversioning';

    return {
      endpoint
    };
  }

  // Vehicle Data Version  filter
  export function vehicleDataVersionFilter() {
    // Get rows
    const getRows = (data) => {
      const rows = [];

      data.forEach((row, i) => {
        // Text/numeric values
        rows[i] = {
          value: row,
          label: parseFloat(row).toFixed(1)
        };
      });

      return rows;
    };

    return {
      getRows: getRows
    };
  }
